module.exports = [
	{
		type: 'Cover',
		props: {
			title: { '?': { var: '$book.title' } },
			subtitle: { '?': { var: '$book.subtitle' } },
			author: { '?': { var: '$book.author' } },
			imageUrl: { '?': { var: '$book.imageUrl' } }
		}
	},
	{
		type: 'Title page',
		props: {
			title: { '?': { var: '$book.title' } }
		}
	},
	{
		type: 'Introduction',
		props: {
			imageUrl:
				'https://oneflow-file-core-api-dev-new-eu-west-1.s3.eu-west-1.amazonaws.com/53342e7b1011064844000168/9bfb0295-2496-430b-86ef-9225026dea8c?AWSAccessKeyId=AKIAJXKUBB3FVPIZFSRA&Expires=1940238087&Signature=cF7lKApP8z4wBYWCUa5dNJ2ylnM%3D&response-content-disposition=attachment%3B%20filename%3D%22intro-v2-1.png%22',
			text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum"
		}
	}
	/*,
	{
		type: 'Table of contents',
		props: {
			pagesCount: 2,
			chapters: { '?': { var: '$book.chapters' } }
		}
	},
	{
		type: 'Chapter',
		props: {
			chapters: { '?': { var: '$book.chapters' } }
		}
	},
	{
		'?': {
			if: [
				{ var: '$props.withNotes' },
				{
					type: 'Notes',
					props: {
						pagesCount: 2,
						linesCount: 17
					}
				},
				{}
			]
		}
	},
	{
		type: 'Acknowledgements page',
		props: {
			text: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum`
		}
	}*/
];
